/* eslint-disable no-useless-escape */
export const Href: string = "#JavaScript";
export const SymbolRegex = /[!@#\$%\^\*\(\)_\+\{\}\[\]:;"'<>,.?/\\|`~=]/g;

export const SignOut: string = "Sign out";
export const MyActive: string = "my active";
export const Language: string = "Language";

export const CarRental: string = "CAR RENTAL";
export const Rental: string = "rental";
export const STEP = 500;
export const THUMB_SIZE = 42;
export const MERGE_THRESHOLD = 300000; 

export const CategoriesTitle: string = "Categories";
export const MostSearchedTitle: string = "Find your dream cars";
export const ServiceTitle: string = "Our Services";
export const WorkTitle: string = "How It Work";
export const ExperienceTitle: string = "Best Customer Experience";
export const AboutTitle: string = "About Us";
export const TestimonialsTitle: string = "Testimonials";
export const OfferTitle: string = "Explore Our Top Deal";
export const Subscribe: string = "Subscribe";
export const ExploreByCategory: string = "Explore by Category";
export const StepBookingTitle: string = "Follow the Steps for Booking";
export const BlogsTitle: string = "Our Blogs";
export const FeaturedCarTitle: string = "Featured Car";
export const AboutSliderTitle: string = "What Say’s Jobholders About Us";
export const NewsletterTitle: string = "Subscribe Newsletter & get Company News.";
export const JobCategoryTitle: string = "Browse Jobs Category";
export const JobHereTitle: string = "Latest Job Here";
export const ApplyNow: string = "Apply Now";
export const JobHiringTitle: string = "Featured Businesses Currently Hiring";
export const Login: string = "Login";
export const Signin: string = "Sign in";
export const UploadResume: string = "Upload Resume";
export const PostProperty: string = "Post Property";
export const Search: string = "Search";
export const BrowseByCategory: string = "Browse by Category";
export const LearnMore: string = "Learn More";
export const PeopleSays: string = "What People Says";
export const LatestJobOpenings: string = "Explore the Latest Job Openings";
export const JobCitiesTitle: string = "Explore Job by Cities";
export const InterviewQuestionTitle: string = "Interview Question for your Dream Job";
export const TopRatedCompany: string = "Top Rated Company";
export const ViewDetails: string = "View Details";
export const OurServiceTitle: string = "Our Services";
export const DiscoveryTitle: string = "Prospects For Discovery";
export const OurAchievementsTitle: string = "Our Achievements";
export const ViewAll: string = "View All";
export const OurTestimonial: string = "Our Testimonial";
export const OurFeaturedProperties: string = "Our Featured Properties";
export const CityTitle: string = "Explore By City";
export const LuxuryCar: string = "Luxury car rental FUSO";
export const FollowUsForMore: string = "Follow us for more";
export const FusoCarRental: string = "Fuso car rental";
export const RentalCar: string = "RENTAL CAR";
export const ChooseUs: string = "Why Choose Us";
export const ReadMore: string = "Read More";
export const Close: string = "Close";
export const OurDedication: string = "Our dedication to ensuring your pleasure and contentment";
export const ShowMore: string = "Show More";
export const WorldBestCompanies: string = "World best companies are hiring on hireup";
export const StepToFollow: string = "Step to follow";
export const ProvideJobs: string = "We Provide a Place to Find Trusted Jobs";
export const ExploreByTestimonials: string = "Explore By Testimonials";
export const MeetOurBrokers: string = "Meet Our Brokers";
export const FeaturedProperties: string = "Featured Properties";
export const Month: string = "month";
export const ViewProperty: string = "View Property";
export const RecentlyAddedProperties: string = "Recently Added Properties";
export const Filters: string = "Filters";
export const LoadMore: string = "Load More";
export const SeeMore: string = "See More";
export const ContactInfoTitle: string = "Contact Info";
export const RequestExplorationTitle: string = "Send Via WhatsApp";
export const SubmitRequest: string = "Submit Request";
export const FeaturedPropertyTitle: string = "Featured Property";
export const RelatedPropertiesTitle: string = "Related Properties";
export const OverviewTitle: string = "Overview";
export const AmenitiesTitle: string = "Amenities";
export const PropertyDescriptionTitle: string = "Property Description";
export const PropertyDetailsTitle: string = "Property Details";
export const FloorPlansTitle: string = "Floor Plans";
export const VideoTitle: string = "Video";
export const LocationTitle: string = "Location";
export const ReviewsTitle: string = "Reviews";
export const WriteReview: string = "Write a Review";
export const SubmitReview: string = "Submit Review";
export const ScheduleTourTitle: string = "Schedule a Tour";
export const Wishlist: string = "Wishlist";
export const RecommendedUsedCarsTitle: string = "Recommended used cars";
export const FeatureTitle: string = "Feature";
export const DescriptionTitle: string = "Description";
export const CarFAQTitle: string = "Car FAQ";
export const AddReviewTitle: string = "Add a Review";
export const MakeOfferPriceTitle: string = "Make an Offer Price";
export const ScheduleTestDriverTitle: string = "Schedule Test Drive";
export const CarOverviewTitle: string = "Car Overview";
export const SimilarJobOpportunities: string = "Similar job opportunities";
export const ReadyToApply: string = "Ready to apply ?";
export const Name: string = "Name";
export const Phone: string = "Phone";
export const Email: string = "Email";
export const UploadYourCV: string = "Upload Your CV";
export const OtherOpportunitiesTitle: string = "Other Opportunities";
export const AboutTheRole: string = "About the Role:";
export const JobLike: string = "What is the Job like?";
export const CanApply: string = "Who can apply?";
export const BenefitsTitle: string = "Benefits:";
export const ApplyForJobTitle: string = "Apply For This Job";
export const Introduction: string = "Introduction";
export const KeyJobDetailsTitle: string = "Key Job Details";
export const BusinessDevelopment: string = "Business Development";
export const SimilarJobsTitle: string = "Similar Jobs";
export const LatestArticleTitle: string = "Latest Article";
export const SocialContactTitle: string = "Social Contact";
export const LeaveCommentTitle: string = "Leave a Comment";
export const CommentTitle: string = "Comment";
export const LuxuryCars: string = "Luxury Cars";
export const BrowseCarService: string = "Browse Car Service";
export const PrimeCarRentals: string = "Welcome to Prime Car Rentals";
export const GetInTouch: string = "Get in Touch";
export const ContactUsTitle: string = "Contact Us";
export const SendMessage: string = "Send Message";
export const Talk: string = "Let's Talk";
export const FollowUs: string = "Follow Us:";
export const OurHappyClients: string = "Our Happy Clients";
export const TeamTitle: string = "Our Experts are like no other";
export const OurFounder: string = "Our Founder";
export const PricingPlanTitle: string = "pricing plan for everyone";
export const FindAnAnswer: string = "Didn't Find An Answer?";
export const Send: string = "Send";
export const FrequentlyQuestions: string = "Frequently Asked Questions";
export const HaveAnyQuestion: string = "Have any question?";
export const LogOut: string = "Log Out";
export const SettingMenu: string = "Setting Menu";
export const DashboardTitle: string = "Dashboard";
export const AmazingDealsTitle: string = "Amazing Deals";
export const LatestCarOrdersTitle: string = "Latest Car Orders";
export const MoreDetails: string = "More Details";
export const JobAppliedTitle: string = "Job Applied";
export const Cancel: string = "Cancel";
export const InteriorInspirations: string = "Interior Inspirations";
export const MyPropertiesTitle: string = "My Properties";
export const PropertyType: string = "Property Type";
export const FurnishingDetailTitle: string = "Furnishing Detail";
export const AreaTitle: string = "Area";
export const PropertyFeaturesTitle: string = "Property Features";
export const PriceDetailsTitle: string = "Price Details";
export const GalleryTitle: string = "Gallery";
export const AddProperty: string = "Add Property";
export const MyProfileTitle: string = "My Profile";
export const PersonalInformation: string = "Personal Information";
export const EditTitle: string = "Edit";
export const Address: string = "Address";
export const SaveChanges: string = "Save Changes";
export const MyFavoritesTitle: string = "My Favorites";
export const UserPrivacy: string = "User Privacy and Data Security Policy";
export const ConditionsTitle: string = "General Terms and Conditions";
export const LogIn: string = "Log In";
export const Welcome: string = "Welcome To Fuso";
export const LogInYourAccount: string = "Log In Your Account";
export const Remember: string = "Remember me";
export const SignUp: string = "Sign Up";
export const DonTHaveAnAccount: string = "Don't have an account?";
export const OR: string = "OR";
export const SignUpAccount: string = "Sign Up Account";
export const AlreadyHaveAnAccount: string = "Already have an Account?";
export const CreateAnAccount: string = "Create An Account";
export const More: string = "More 10+";
export const CarHomeLabel: string = "#DriveYourDreamAdventure";
export const CarHomeSubLabel: string = "Discover your Next Adventure on Wheels";
export const CarHomeContentLabel: string = "Discover a world of possibilities and start your next unforgettable journey today.";
export const TopBusiness: string = "Top businesses in the world are recruiting on hire up";
export const DreamJobEasily: string = "Get your Dream Job Easily";
export const TrustedReal: string = "Trusted real estate properties for you";
export const MeetOurTeam: string = "Meet Our Team";
export const TrustedJobs: string = "We Provide a Place to Find Trusted Jobs";
export const BuildYourFuture: string = "Build your future with us";
export const FindYourJob: string = "Find your job & make sure goal.";
export const GetYour: string = "Get your";
export const DreamJob: string = "Dream Job";
export const MakeYourOwnGoals: string = "and Make your Own Goals.";
export const NextJob: string = "Find your Next Job and Make your Own Goal";
export const BrowseToAllJob: string = "Browse to all Job";
export const FindTrustedJobs: string = "We Provide a Place to Find Trusted Jobs";
export const DiscoverMore: string = "Discover more";
export const DiscoverSuitableReal: string = "Discover suitable real estate for your family";
export const YearsOfExperience: string = "years of Experience";
export const RemarkableAndTrustworthy: string = "We are the most remarkable and trustworthy real estate";
export const DiscoverSuitable: string = "Discover suitable";
export const RealEstate: string = "real estate";
export const YourFamily: string = "for your family";
export const ShareIt: string = "Share It";
export const Share: string = "Share";
export const Print: string = "Print";
export const Save: string = "Save";
export const ForSale: string = "For Sale";
export const DropFilesToAttach: string = "Drop files to attach";
export const MaxFileUpload: string = "max file upload size 6 mb";
export const JoinTalentNetwork: string = "Join Talent Network";
export const Bedroom: string = "Bedroom";
export const OverallRatings: string = "Overall Ratings";
export const WasThisHelpful: string = "Was this helpful?";
export const SelectYourTime: string = "--Select Your Time--";
export const PropertyMainLabel: string = "Luxury 3-Bedroom Mansion with Pool";
export const PropertyLocation: string = "Vasant Kunj, New Delhi, Vasant Kunj, New Delhi - South, Delhi NCR";
export const CarMainLabel: string = "Velocity Racer Pro";
export const CarLocation: string = "Shifts gears automatically based on the car's speed and acceleration.";
export const JobMainLabel: string = "Allies Infotech";
export const JobLocation: string = "Puerta 830 Grupo Norma Munguía 50 Puerta 890, San Sebastían de los Reyes, Man 74332";
export const Applicants: string = "Applicants:";
export const ContactLabel: string = "Calvin";
export const ContactEmail: string = "ccautoworldsdnbhd@gmail.com";
export const ContactLocation: string = "E-G-32, BLOCK E, Taipan 2, Jalan PJU 1A/3, Ara Damansara, 47301, Petaling Jaya, Selangor.";
export const AtThisTime: string = "Don’t see a fit at this time?";
export const KeyJobDetailsContent: string = "Be at ease. Become a member of our Talent Network to receive updates on the newest positions.";
export const NoMoreProductsAvailable: string = "No more products available.";
export const FilterJobsBySalary: string = "Filter jobs by salary";
export const FindTheseJobs: string = "How relevant do you find these jobs?";
export const ExperienceDoYouHave: string = "How much experience do you have?";
export const ShareWithAFriend: string = "Share with a Friend";
export const ForThisJob: string = "Have a friend who’ll be good for this job?";
export const DownloadNow: string = "Download Now";
export const UsersAreOnTheFusoApp: string = "10M+ Users are on the Fuso app";
export const JobsYouMightBeInterested: string = "Jobs you might be interested in";
export const ClearAll: string = "Clear All";
export const Filter: string = "Filter";
export const SortBy: string = "Sort By :";
export const Popular: string = "Popular";
export const Others: string = "Others";
export const BrandAndModel: string = "Brand + Model";
export const ExploreOnMap: string = "Explore on map";
export const EffectiveDate: string = "Effective Date:";
export const GoToHomePage: string = "Go To Home Page";
export const WhoopsPageNotFound: string = "Whoops ! Page Not Found";
export const FindAPlaceYouWillLove: string = "Find a Place you will Love.";
export const DiscoverOurProduct: string = "To discover our product and its features";
export const AreYouLoggingOut: string = "Are You Logging Out?";
export const ProfileName: string = "Larry Bishop";
export const ProfileEmail: string = "LarryMBishop@rhyta.com";
export const ProfileNumber: string = "773-531-4157";
export const Yes: string = "Yes";
export const No: string = "No";
export const ClickToUpload: string = "Click to upload, or drop files here.";
export const PriceInclude: string = "Price Include";
export const Registration: string = "Stamp Duty & Registration charges excluded.";
export const ComfortableInterior: string = "Comfortable Interior";
export const Phantom: string = "Phantom";
export const Unbeatable: string = "Make a Big Splash with Unbeatable Sale Prices!";
export const RealEstateAgent: string = "Real Estate Agent";
export const LeedsUnitedKingdom: string = "Leeds, United Kingdom";
export const HouseInAmsterdam: string = "House in Amsterdam";
export const Home: string = "Home";
export const Featured: string = "Featured";
export const Rent: string = "Rent";
export const ClassicDesign: string = "Classic design";
export const BookNow: string = "Book Now";
export const PerDay: string = "Per day";
export const PartTime: string = "Part Time";
export const FullTime: string = "Full Time";
export const MidLevel: string = "Mid Level";
export const PeopleView: string = "25 People View";
export const ShowcaseOfSuccess: string = "Showcase of Success";
export const Reset: string = "Reset";
export const Collection: string = "Collection";
export const SingleJob: string = "Single-job";
export const NoMoreBlogAvailable: string = "No more Blog available.";
export const BestTopArticles: string = "Best Top Articles";
export const BlogDetailLabel: string = "Road Warriors: Adventure Awaits with the Perfect Ride";
export const RoseRoberts: string = "Rose Roberts";
export const AboutTheAuthor: string = "About the author";
export const FounderAndWriter: string = "Founder & Writer";
export const LastUpdate: string = "Last Update:";
export const CategorizedIn: string = "Categorized in:";
export const UnveilingTheWondersOfKnowledge: string = "Unveiling the Wonders of Knowledge";
export const Shortlist: string = "Shortlist";
export const ProfileTitle: string = "Profile";
